module.exports = __webpack_public_path__ + "static/media/image-403.555c1880.svg";